// extracted by mini-css-extract-plugin
export var iconContainer = "A+LFb";
export var valueBlub = "-Nrgs";
export var valueDescription = "vBKbY";
export var valueIcon = "cTkkr";
export var valueListItem = "CBpbk";
export var valueTitle = "_78DWH";
export var valuesList = "aaFVl";